/**
 * Skeleton loading components for PA pages
 */
import { cn } from '@/lib/utils';

export function SkeletonPulse({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-lg bg-white/[0.06]', className)} />;
}

export function SkeletonHomePage() {
  return (
    <div className="px-5 py-6 max-w-lg mx-auto space-y-7">
      <div><SkeletonPulse className="h-9 w-64 mb-2" /><SkeletonPulse className="h-4 w-48" /></div>
      <SkeletonPulse className="h-20 w-full rounded-2xl" />
      <div className="grid grid-cols-2 gap-3">
        {[1,2].map(i => <SkeletonPulse key={i} className="h-14 w-full rounded-xl" />)}
      </div>
      <div className="space-y-3">
        <SkeletonPulse className="h-3 w-24" />
        {[1,2,3].map(i => <SkeletonPulse key={i} className="h-20 w-full rounded-xl" />)}
      </div>
      <div className="grid grid-cols-2 gap-3">
        {[1,2,3,4].map(i => <SkeletonPulse key={i} className="h-24 w-full rounded-xl" />)}
      </div>
    </div>
  );
}

export function SkeletonEmailList() {
  return (
    <div className="space-y-1">
      {[1,2,3,4,5,6].map(i => (
        <div key={i} className="p-3 rounded-xl border border-white/[0.04] bg-zinc-900/20">
          <div className="flex items-start gap-3">
            <SkeletonPulse className="w-8 h-8 rounded-full shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="flex justify-between"><SkeletonPulse className="h-4 w-28" /><SkeletonPulse className="h-3 w-12" /></div>
              <SkeletonPulse className="h-4 w-48" />
              <SkeletonPulse className="h-3 w-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonCalendar() {
  return (
    <div className="px-4 py-6 max-w-lg mx-auto space-y-4">
      <SkeletonPulse className="h-6 w-32" />
      <SkeletonPulse className="h-10 w-full rounded-xl" />
      <div className="space-y-3">
        <SkeletonPulse className="h-3 w-20" />
        {[1,2,3].map(i => <SkeletonPulse key={i} className="h-16 w-full rounded-xl" />)}
        <SkeletonPulse className="h-3 w-24 mt-4" />
        {[1,2].map(i => <SkeletonPulse key={i} className="h-16 w-full rounded-xl" />)}
      </div>
    </div>
  );
}

export function SkeletonPulse2() {
  return (
    <div className="px-5 py-6 max-w-lg mx-auto space-y-4">
      <SkeletonPulse className="h-6 w-32" />
      <div className="space-y-3">
        {[1,2,3,4,5].map(i => (
          <div key={i} className="flex items-start gap-3 p-4 rounded-xl border border-white/[0.04]">
            <SkeletonPulse className="w-8 h-8 rounded-full shrink-0" />
            <div className="flex-1 space-y-2">
              <SkeletonPulse className="h-4 w-32" />
              <SkeletonPulse className="h-3 w-full" />
              <SkeletonPulse className="h-3 w-2/3" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
